(function ($) {
  $("a.uk-navbar-toggle").on("click", function () {
    // switch the background color to dark colour
    $(".header-section").toggleClass("mobile-dark-header");

    // Prevent scrolling when hamburger menu is open
    $("body").toggleClass("no-scroll");
  });
})(jQuery);
